import { render, staticRenderFns } from "./BeefDisease.vue?vue&type=template&id=1960e775&"
import script from "./BeefDisease.vue?vue&type=script&lang=js&"
export * from "./BeefDisease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports